module.exports = __webpack_public_path__ + "media/application/images/home/jugend-ae3c5be67586c4e779cdb072791f6db1.svg";